import { createFileRoute } from '@tanstack/react-router';
import { FindWorkspace } from '@features/eor/FindWorkspace';

export const Route = createFileRoute('/eor/find')({
  component: FindWorkspace,
});
